import axios from 'axios'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { constants } from '../Constants'
import { ModalAddEvent } from '../components/Modals/ModalAddEvent'
import { ModalRegisterUser } from '../components/Modals/ModalRegisterUser'
import { PageLoader } from '../components/ui/Spinner/Spinner'
import '../styles/shared.scss'

export const Dashboard = () => {
  const [userCount, setUserCount] = useState(0)
  const [categories, setCategories] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const loadData = async () => {
    setIsLoading(true)
    try {
      const userResponse = await axios.get(`${constants.urlLocal}countUsers`)
      setUserCount(userResponse.data.count)
      const categoryResponse = await axios.get(
        `${constants.urlLocal}categories/getAll`
      )
      setCategories(categoryResponse.data.categories)
    } catch (error) {
      console.error('Error al obtener los datos', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadData()
  }, [])

  if (isLoading)
    return (
      <div className="loading-center">
        <PageLoader />
      </div>
    )

  const stats = [
    {
      icon: '👥',
      title: 'Todos los usuarios',
      stat: userCount,
      color: '#2440ab',
      path: '/all-users',
    },
    {
      icon: '📂',
      title: 'Categorías creadas',
      stat: categories.length,
      color: '#e67e22',
      path: '/all-categories',
      state: { categories },
    },
    {
      icon: '📊',
      title: 'Estadísticas',
      stat: '',
      color: '#28a745',
      path: '/statistics',
      state: { categories },
    },
    {
      icon: '🕐',
      title: 'Horarios y Clases',
      stat: '',
      color: '#6f42c1',
      path: '/schedule',
      state: { categories },
    },
    {
      icon: '📢',
      title: 'Comunicaciones',
      stat: '',
      color: '#dc3545',
      path: '/comunications',
    },
    {
      icon: '📧',
      title: 'Emails',
      stat: '',
      color: '#6c757d',
      path: '/emails',
    },
  ]

  return (
    <div className="page-container">
      <h1 className="page-title">Panel de Control</h1>
      <hr className="divider" />
      <p className="page-subtitle">
        Bienvenid@ al panel de control. Aquí podrás ver estadísticas y otras
        cosas.
      </p>
      <hr className="divider" />
      <div
        style={{
          display: 'flex',
          gap: '0.75rem',
          marginBottom: '1.5rem',
          flexWrap: 'wrap',
        }}
      >
        <ModalAddEvent
          triggerLabel="＋ Crear clase"
          triggerVariant="primary"
          triggerStyle={{}}
          onCreated={loadData}
        />
        <ModalRegisterUser fetchCounts={loadData} />
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: '1rem',
        }}
      >
        {stats.map(s => (
          <Link
            to={s.path}
            state={s.state}
            key={s.title}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div
              className="card-box"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                cursor: 'pointer',
                transition: 'transform 0.2s, box-shadow 0.2s',
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'scale(1.02)'
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'scale(1)'
                e.currentTarget.style.boxShadow = ''
              }}
            >
              <span style={{ fontSize: '2rem' }}>{s.icon}</span>
              <div>
                <p style={{ fontWeight: 700, fontSize: '0.875rem' }}>
                  {s.title}
                </p>
                {s.stat !== '' && (
                  <p
                    style={{
                      fontSize: '1.5rem',
                      fontWeight: 600,
                      color: s.color,
                    }}
                  >
                    {s.stat}
                  </p>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
